<div class="content">
  <div class="agreementText" #textContainer (scroll)="updateScrollPosition(textContainer)">
    <p class="documentTitle">
      <b>
        <span>
          Disclaimer: Use of EnCompass Ratings and Fan Coil Selection Program
        </span>
      </b>
    </p>
    <p class="standardText">
      <span>
        Please read this disclaimer carefully before accessing or using the Encompass Ratings and Fan Coil Selection Program (“Program” or “Encompass”). This Program is designed to solely assist the user (“user” or “you”) in the selection of products, and specification of products of The Climate Control Group, Inc. (“CCG”) and any of its affiliates.
      </span>
    </p>
    <p class="standardText">
      <strong>
        <span>
          USER RESPONSIBILITY.
        </span>
      </strong>
    </p>
    <p class="standardText">
      <strong>
        <span>
          You acknowledge that the Program is a tool designed to assist you in achieving your intended goals. The ultimate responsibility for the accuracy or suitability of any output or results generated by the Program rests with you. CCG and any of its affiliates assumes no responsibility and makes no warranty regarding the accuracy of data generated by, or contained within, this Program.
        </span>
      </strong>
    </p>
    <p class="standardText">
      <strong>
        <span>OWNERSHIP.</span>
      </strong>
    </p>
    <ol class="listContainer" type="a">
      <li>
        CCG and user acknowledge that the Program referenced herein includes software in which CCG may have no ownership or other proprietary rights and no such title shall be transferred to user hereunder.
      </li>
      <li>
        User of the Program agrees and acknowledges that no proprietary interest is being transferred or conveyed to user by either this disclaimer or by the use of the Program.
      </li>
    </ol>
    <p class="standardText">
      <strong>
        <span>WARRANTY AND DISCLAIMERS.</span>
      </strong>
    </p>
    <ol class="listContainer" type="a">
      <li>
        Neither CCG nor its contributors nor its agents nor its affiliates shall be held liable for any improper or incorrect use of the Program.
      </li>
      <li>
        Neither CCG nor its contributors nor its agents nor its affiliates shall be held liable for any damages, of any kind, whether in contract, strict liability, tort (including negligence or otherwise), or any other theory arising in
        any way out of the use of the Program.
      </li>
      <li>
        You understand and agree that to the extent permitted by applicable law, your use of the Program is at your sole risk, and the Program is provided “AS IS”, WITHOUT WARRANTY OF ANY KIND EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT.
      </li>
      <li>
        CCG AND/OR ITS AFFILIATES SHALL NOT BE LIABLE TO YOU OR ANY OTHER PERSON FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR OTHER DAMAGES OF ANY CHARACTER, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFIT,
        DATA, GOODWILL, WORK STOPPAGE, COMPUTER FAILURE, PROCUREMENT OF REPLACEMENT PROGRAMS, OR MALFUNCTION, OR ANY AND ALL OTHER DAMAGES OR LOSSES ARISING OUT OF THE USE OR INABILITY TO USE THE PROGRAM, EVEN IF CCG AND ITS AFFILIATES
        SHALL HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </li>
      <li>
        This Program is provided on an &quot;as is&quot; and &quot;as available&quot; basis, with all faults. This section does not affect in any way our terms and conditions or limited warranty for Products purchased by you and the terms
        and conditions or limited warranty for Products purchased by you in no way apply to the use of the Program.
      </li>
      <li>
        CCG and/or any of its Affiliates make no warranty, representation or condition that: (1) the Program will meet your requirements; (2) your use of the Program will be uninterrupted, timely, secure or error-free; or (3) the results
        that may be obtained from use of the Program will be accurate or reliable.
      </li>
      <li>
        Any content downloaded from or otherwise accessed through the Program is accessed at your own risk, and you shall be solely responsible for any damage to your property, including, but not limited to, your computer system, mobile
        device, and any other device you use to access the Program, or any other loss that results from accessing such content.
      </li>
      <li>
        No advice or information, whether oral or written, obtained from CCG and/or any of its affiliates or through the Program will create any warranty not expressly made herein.
      </li>
      <li>
        You acknowledge and agree that CCG and/or its affiliates are not liable, and you agree not to seek to hold CCG and/or its affiliates liable for the conduct of third parties, including operators of external sites, and that the risk
        of injury from such third parties rests entirely with you.
      </li>
      <li>
        You understand and agree you are not purchasing the Program. The Program is a service that we provide free of charge, and without warranty of any kind, express, implied, or otherwise.
      </li>
      <li>
        CCG and/or its affiliates are not responsible or liable for any loss or damage of any sort incurred as the result of your dealings with third party advertisers, or as the result of the presence of such advertisers interacting with
        the Program.
      </li>
      <li>
        Any Program may contain inaccuracies or typographical errors. Changes, corrections, and improvements may be made periodically to the Program and will be incorporated in new versions or updates.
      </li>
      <li>
        Changes, corrections and/or improvements to the Program may be made at any time without notice.
      </li>
      <li>
        CCG and its affiliates are dedicated to continuous product development and reserve the right to change specifications or discontinue products without notice. The Climate Control Group, Inc. reserves the right to change or update
        this Program without notice.
      </li>
    </ol>
    <p class="standardText">
      <strong>
        <span>LIMITATION OF LIABILITY.</span>
      </strong>
    </p>
    <ol class="listContainer" type="a">
      <li>
        CCG and/or its affiliates entire liability, including but not limited to damages or injuries caused by any failure of performance, error, omission, interruption, deletion, defect, delay in operation or transmission, computer virus,
        communication line failure, and/or theft, destruction or unauthorized access to, alteration of, or use of any record and your exclusive remedy shall be a return of the purchase price, if any, for the Program.
      </li>
      <li>
        In the event no price was paid for said Program, you agree there will be no liability on the part of CCG and/or its affiliates. including but not limited to liability for damages or injuries caused by any failure of performance,
        error, omission, interruption, deletion, defect, delay in operation or transmission, computer virus, communication line failure, and/or theft, destruction or unauthorized access to, alteration of, or use of any record.
      </li>
    </ol>
    <p class="standardText">
      <b>
        <span>Indemnification</span>
      </b>
    </p>
    <p class="standardText">
      <span>
        User agrees to defend, indemnify, and hold harmless, CCG and/or its’ affiliates against all claims and expenses, including attorneys' fees, arising out of the use of the on-line service by user or user's account.
      </span>
    </p>
    <p class="standardText">
      <b>
        <span>Disclaimer of Endorsement
        </span>
      </b>
    </p>
    <ol class="listContainer" type="a">
      <li>
        CCG and/or its’ affiliates may be, from time to time, distributors of content supplied by third parties and users within the Program. Any opinions, advice, statements, services, offers, or other information or content expressed or
        made available by third parties, including information providers, users, or others, are those of the respective author(s) or distributor(s) and do not necessarily state or reflect those of CCG and/or its’ affiliates.
      </li>
      <li>
        Reference within the Program to any specific commercial products, process, or service by trade name, trademark, manufacturer, or otherwise, does not constitute or imply its endorsement, recommendation, or favoring by CCG and/or its’
        affiliates.
      </li>
      <li>
        Reference within the Program to any specific commercial products, process, or service by trade name, trademark, or manufacturer, shall not be used for advertising or product endorsement purposes.
      </li>
    </ol>
    <p class="standardText">
      <b>
        <span>Choice of Law</span>
      </b>
    </p>
    <p class="standardText">
      <span>
        Construction of the disclaimers above and resolution of disputes thereof are governed by the laws of the State of Oklahoma.
      </span>
    </p>
    <p class="standardText">
      <b>
        <span>Copying of Documents</span>
      </b>
    </p>
    <ol class="listContainer" type="a">
      <li>
        User understands and agrees that no copies of any proprietary or non-proprietary information contained in the Program will be made.
      </li>
      <li>
        The Program may contain proprietary notices and copyright information relating to individual documents or the site as a whole. Nothing contained herein shall be construed as conferring by implication or otherwise any license or
        right under any patent or trademark to the proprietary information.
      </li>
      <li>
        Nothing contained herein shall be construed as conferring any license or right under any copyright.
      </li>
    </ol>
    <p class="standardText">
      <strong>
        <span>Termination.</span>
      </strong>
    </p>
    <p class="standardText">
      <strong>
        <span>
          We reserve the right to terminate or suspend your access to the Program at any time, without prior written notice <u>or liability</u>, for any reason whatsoever.
        </span>
      </strong>
    </p>
  </div>
  <div class="instructionContainer">
    <span class="spacer"></span>
    @if (!isScrolledToBottom()) {
      <label class="instructionLabel">Please scroll to the bottom of the agreement to accept</label>
    }
    <span class="spacer"></span>
  </div>
  <div class="buttonRow">
    <button class="warn-button" matButton="elevated" (click)="decline()">I Disagree (Close)</button>
    <span class="spacer"></span>
    <button class="primary-button" matButton="elevated" [disabled]="!isScrolledToBottom()" (click)="accept()">I Agree (Continue)</button>
  </div>
</div>
